module.exports = __webpack_public_path__ + "img/组2.da456ce2.png";